<template>
    <div class="TicketSystemFaq">
		<div class="my-2">
			<div class="filter-tag-row">
				<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
				<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Элементов: {{this.masApi_total}}</span>
			</div>	
			<div class="col-lg-8" v-show="bShowFilter">
				<ReFilter :masAllFilterParams="masAllFilterParams" 
					v-model="objGetParams" 
					v-on:filterapply="OnFilterApply"
				/>
			</div>
		</div>

		<card class="mt-3" v-if="!bIsEdit && (this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1)">
			<div >
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить новую запись faq в таблицу</h5>
			</div>

			<ReFormPrinter 
			:masFormConfig="masAllFormParams" 
			:objSaveApiMethod="currentApiFormMethod"		
			:SuccessGo="SuccessGo"
			SuccessBtnText="Добавить FAQ"/>

		</card>

		<card
			v-if="!bIsEdit"
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
			class="mt-3">
			<el-table 
				:data="ApiData" 
				style="width: 100%;"
			>
			<el-table-column
				label="id"
				property="id"
				width="80"
			>
			</el-table-column>

			<el-table-column 
				width="180"
				label="Тема заявки"
				property="topicTag"
			>
				<template v-slot="scope" >
					<span v-for="tg in masTopicTags" :key="tg.id">
						<span v-if="scope.row.topicTag == tg.id"  class="el-tag el-tag--small el-tag el-tag--primary mr-2">{{tg.value}}</span>	
					</span>
					
				</template>
			
			</el-table-column>
			<el-table-column
				label="name"
				property="name"
				width="300"
			>

			</el-table-column>
			<el-table-column
				label="descr"
				property="descr"
				width="500"
			>

			</el-table-column>
			<el-table-column
				label="photos"
				property="photos"
				width="300"
			>

			</el-table-column>
			<el-table-column
				width="110"
				label=""
				align="right"                    	
			>
				<template v-slot="scope">						
					<ReActionBtns :masActions="masActions[scope.$index]"/>
				</template>
			</el-table-column>

			<el-table-column
					width="140"
					label="Действие"
					align="right" 
				>
					<template v-slot="scope">	
						<div class="d-flex ">
						<!-- <el-button class="no-border my-0"></el-button> -->
							
							<button class="ml-3 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
								<i class="tim-icons icon-trash-simple"></i>
							</button>	
																	
								
						<!-- <el-button class="no-border my-0" ></el-button> -->
							
							<button class="ml-3 btn btn-icon btn-simple btn-primary" @click="GoToEdit(scope.row)">
								<i class="tim-icons icon-pencil"></i>
							</button>	
																	
						
					</div>
					</template>
			</el-table-column>
			
			</el-table>
			
			<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masApi_total)" 
				:perPage="parseInt(10)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>

		<template v-if="this.ApiData.length > 0">
			<div class="col-md-9 col-12">
				<h6>ниже вид из текстарии с разметкой. Этот компонент мы будем показывать пользователям</h6>
				<ReCardTicketFaq :objFAQ="faq" v-for="faq in ApiData" :key="faq.id" />
			</div>
		</template>

	</div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';


export default {
	name: 'TicketSystemFaq-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// BaseSwitch,
        ReFormPrinter,
        Pagination,
		ReActionBtns,
		ReFilter,
		ReFilterBtn,
		ReCardTicketFaq,
	},
	data() {
		return {
			ApiData: [],
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			masApi_total: 0,
			count2page: 10,
			masActions:[],	
			masTopicTags: [],
			fullscreenLoading: false,
			bShowFilter: false,
			bIsEdit: false,
			currentApiFormMethod: this.currentApiFormMethodComp(),
			masAllFormParams: this.currentFormConfig(),
			bShowForm: false,
		};
	},
	watch: {

	},
	computed: {

	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}

			this.$GVO.ApiCall('TicketSystem.GET_TicketFAQ',{flt: {...filter,} }) /**/
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;

						this.masActions = [];
						for (let i = 0; i < this.ApiData.length; i++) {
							if(this.ApiData[i].read_only==1)
								this.masActions.push([]);
							else
								this.masActions.push([
									{
										actionType: 'switcher',
										label_on: 'Вкл',
										label_off: 'Выкл',
										action_model: this.ApiData[i].act=='1'?true:false,						
										onClickApi: {apiMethod:'CHANGE_ACT_FAQ',apiParam:{obj:'TicketSystem',flt:{id:this.ApiData[i].id}}},
									},
									// {
									// 	actionType: 'btn_del',
									// 	onClickApi: {apiMethod:'DEL_TICKET_FAQ',apiParam:{obj:'TicketSystem',flt:{id:this.ApiData[i].id }}},
									// },
									
								]);
						}
					}
					if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
				}else{
					this.ApiData = [];
					this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masApi_total=0; console.error(errorObjApi);});
		},
		currentApiFormMethodComp(){
			return {apiMethod:'INS_TICKET_FAQ',apiParam:{obj:'TicketSystem' ,flt:{},iData:[]}};
		},
		currentFormConfig(){
			this.$GVO.ApiCall('GET_FORM_TICKET_FAQ',{obj:'TicketSystem',flt:{}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		SuccessGo(/* evt,dopParam */){
	        this.masAllFormParams = this.currentFormConfig();
			this.getApiData();
		},	
		// GoToEdit(bGoEdit=true){
		// 	//this.bIsEdit = bGo;
		// 	if(location.pathname.indexOf('/data/ticketsystem/add') != -1){
		// 		this.$router.push({path: '/data/ticketsystem'});
		// 	}else{
		// 		this.$router.push({path: '/data/ticketsystem/id/'+this.$route.params.ticket_id});
		// 	}
			
		// },
		GoToEdit(rowData){
			//location.href = `/data/ColdCall/id/${rowData.id}`; 
			// this.$router.push({path: `/data/TicketSystem/faq/id/${rowData.id}`});
			this.$router.push({path: '/data/TicketSystem/faq/id/'+rowData.id+'/edit'});
		},
		DeleteRow(row){
			if(row.id != null){
				this.$GVO.ApiCall('TicketSystem.DEL_TICKET_FAQ',{ flt:{id: row.id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER_TICKET_FAQ',{obj:'TicketSystem'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			// return require('src/conf/supportFilterConfig.js').support_FilterConfig;
			return [];
		},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},	

		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},

		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},


	},		
	created(){

	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();

		this.$GVO.LoadCatPromise('CAT_TICKET_TAGS')
		.then((objApi) => {
			if(objApi=== true){
				for (let i = 0; i < this.$GVO.cats.CAT_TICKET_TAGS.length; i++) {
					const element = this.$GVO.cats.CAT_TICKET_TAGS[i];
					if(element.act==1) this.masTopicTags.push({'value':element.val,'label':element.val, 'id':element.id}); //вопрос val или id ?
				}
			}
		})
		.catch(errorObjApi => {console.error(errorObjApi); });

		// this.getApiData();
	}
};
</script>
<style scoped>

/* .TicketSystemFaq >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);} */
.TicketSystemFaq >>>  .el-table table {width: 100%!important;}
.TicketSystemFaq >>>  .el-table .cell {word-break: break-word;}

.TicketSystemFaq >>> .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.TicketSystemFaq >>> .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: baseline;
	flex-wrap: wrap;
}
.TicketSystemFaq >>> .form-options-group > div{
	margin-right: 5px;
}
.TicketSystemFaq >>> .form-group {
	margin-bottom: 0px!important;
}
.TicketSystemFaq >>> .cell {
	word-break: break-word!important;
	/* line-height: 10px; */
}
/* .TicketSystemFaq >>> .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
} */

@media (max-width: 576px){
		.filter-tag-row {padding: 0 15px;}
	}

</style>
